import { apiClient } from "lib/apiClient";

export const deletePropertyPhotos = async <T>(ids: string[]): Promise<T> => {
  const response = await apiClient.delete(`/properties/photoDeletion/`, {
    data: ids,
  });

  return response.data;
};
